var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dc-button",class:[
        _vm.type ? 'dc-button--' + _vm.type : '',
        _vm.buttonSize ? 'dc-button--' + _vm.buttonSize : '',
        {
            'is-disabled': _vm.buttonDisabled,
            'is-loading': _vm.loading,
            'is-plain': _vm.plain,
            'is-round': _vm.round,
            'is-circle': _vm.circle
        }
    ],attrs:{"disabled":_vm.buttonDisabled || _vm.loading,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[_c('font-awesome-icon',{attrs:{"icon":_vm.iconName}}),(_vm.loading)?_c('i',{staticClass:"dc-icon-loading"}):_vm._e(),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }